import React from "react";
import { connect } from "react-redux";
import language from "../../../language/index.js";
import { Table } from "../../Table/index.js";
import { DeleteModal, Modal } from "../../Modal/index.js";
import { defineRole } from "../../../utils/handleAccessRoles.js";
import icons from "../../../constants/icons.js";
import { ROLE_DISTRIBUTION, ROLE_REQUEST, ROLE_BLOOD_TEST } from "../../../constants/ROLES.js";
import { Empty } from "../../Empty/index.js";
import handleSearch from "../../../utils/handleSearch.js";
import UpdateShipping from "./UpdateShipping.js";
import ShippingInQueue from "./ShippingInQueue.js";
import Button from "../../Button/Button.js";
import { deleteQueue } from "../../../utils/queries/request/shipping-queue.js";
import { getStorage } from "../../../utils/storage.js";
import { onGenerateShipmentNumber } from "../../../actions/ShipmentNumber.js";
import api from "../../../utils/api";
import toastMessage from "../../../utils/toastMessage";
import moment from "moment";
import { deleteReturnedProducts } from "../../../utils/queries/return-product.js";
import { onGenerateReturnNumber } from "../../../actions/ReturnNumber.js";
import UpdateReturnProduct from "../../return/UpdateReturnProduct.js";
let copyData = [];

class ListShippingQueue extends React.Component {
  state = {
    user: {},
    modalTitle: "",
    selectedData: {},
    error: "",
    delete_password: "",
    delete_value: "",
  };

  componentDidMount = async () => {
    const user = await getStorage();
    const canViewDonation = defineRole({
      roles: user.accessRole,
      menu: ROLE_BLOOD_TEST,
      operation: "read",
    });

    this.setState({ user, canViewDonation });
  };
  returnTableHeaders() {
    if (this.props.isReturn) {
      return [
        {
          title: "#",
          type: "numbering",
        },
        {
          title: language[this.props.defaultLanguage].return_number,
          key: "returnId.returnNumber",
          styles: {
            textTransform: "uppercase",
          },
        },
        {
          title: language[this.props.defaultLanguage].donation,
          key: "donation.donationNumber",
          ...(this.state.canViewDonation && {
            type: "link",
            onPress: (item) =>
              (window.location.href = `/dashboard/donations/${item.donation._id}/${item.donation.donor}`),
          }),
        },
        {
          title: language[this.props.defaultLanguage].product,
          key: "inventory.code",
        },
        {
          title: language[this.props.defaultLanguage].blood_group,
          key: "inventory.bloodGroup",
          styles: {
            textTransform: "uppercase",
          },
        },
        {
          title: language[this.props.defaultLanguage].source,
          key: "returnId.from.name",
        },
        {
          title: language[this.props.defaultLanguage].destination,
          key: "returnId.to.name",
        },
        {
          title: language[this.props.defaultLanguage].added_by,
          key: "addedBy.pin",
        },
        {
          title: language[this.props.defaultLanguage].date,
          key: "createdAt",
          isMoment: true,
          formatTime: "lll",
        },
        {
          title: language[this.props.defaultLanguage].status,
          key: "status",
          type: "status",
        },
        {
          title: language[this.props.defaultLanguage].actions,
          key: "action",
        },
      ];
    }
    return [
      {
        title: "#",
        type: "numbering",
      },
      {
        title: language[this.props.defaultLanguage].shipment_number,
        key: "shipmentNumber",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].donation,
        key: "donation.donationNumber",
        type: "link",
        onPress: (item) =>
          (window.location.href = `/dashboard/donations/${item.donation._id}/${item.donation.donor}`),
      },
      {
        title: language[this.props.defaultLanguage].product,
        key: "product",
      },
      {
        title: language[this.props.defaultLanguage].blood_group,
        key: "inventory.bloodGroup",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].source,
        key: "from.name",
      },
      {
        title: language[this.props.defaultLanguage].destination,
        key: "service.name",
        fallbackKey: "to.name",
      },
      {
        title: language[this.props.defaultLanguage].added_by,
        key: "addedBy.pin",
      },
      {
        title: language[this.props.defaultLanguage].date,
        key: "createdAt",
        isMoment: true,
        formatTime: "lll",
      },
      {
        title: language[this.props.defaultLanguage].status,
        key: "status",
        type: "status",
      },
      {
        title: language[this.props.defaultLanguage].actions,
        key: "action",
      },
    ];
  }

  handleShowModal(modal, modalTitle, selectedData = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selectedData,
      reason: selectedData.reason || "",
    });

    if (selectedData?.donation) {
      this.setState({ donation: selectedData.donation });
    }
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
    this.props.dispatch(onGenerateShipmentNumber(false));
  }

  onDelete = async () => {
    try {
      this.setState({ isDeleting: true });

      if (this.props.isReturn) {
        await deleteReturnedProducts(
          this.props.defaultLanguage,
          this.state.selectedData._id
        );
      } else {
        await deleteQueue(
          this.props.defaultLanguage,
          this.state.selectedData._id,
          this.props.isForNominative ? "NOMINATIVE" : undefined
        );
      }

      this.setState({ isDeleting: false });

      this.props.getData(true);
      this.handleCloseModal("showDeleteModal");
    } catch (error) {
      this.setState({
        isDeleting: false,
      });
    }
  };

  handlePagination(page, _tab, limit) {
    this.setState(
      {
        page,
        ...(limit != null && { limit }),
      },
      () => {
        this.props.getData(true);
      }
    );
  }

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      [field]: e && e?.target ? e?.target?.value : e,
      error,
    });
  }

  handleUpdateRequest = async (
    isLoading,
    { id, status, shipmentNumber, from, to, requestNo, requestType }
  ) => {
    if (!id)
      return toastMessage(
        "error",
        language[this.props.defaultLanguage].no_data
      );

    if (this.props.isReturn) {
      await this.handleReturn(isLoading, {
        id,
        status,
        returnNumber: this.props.selectedData.returnNumber,
        from,
        to,
        requestNo,
        requestType,
      });
      this.handleCloseModal("showPrint");
      this.props.handleClose?.();
      return;
    }

    await this.handleRequest(isLoading, {
      id,
      status,
      shipmentNumber,
      from,
      to,
      requestNo,
      requestType,
    });
    this.handleCloseModal("showPrint");
    this.props.handleClose?.();
    this.props.getData?.(true);
  };

  handleReturn = async (
    isLoading,
    { id, status, returnNumber, from, to, requestNo, requestType }
  ) => {
    try {
      this.setState({
        [isLoading]: true,
      });

      this.props.dispatch(onGenerateReturnNumber(true));

      const API_URL = process.env.REACT_APP_BBMS_BASE_API;

      const options = {
        method: "PUT",
        url: `${API_URL}/return-request`,
        data: {
          id,
          returnNumber,
          status: "transferred",
          requestType,
        },
        headers: {
          Authorization: `Bearer ${this.state.user.token}`,
        },
      };

      await api(options);

      this.setState({
        [isLoading]: false,
      });

      this.props.dispatch(onGenerateReturnNumber(false));

      this.props.getReturnRequest && this.props.getReturnRequest(true);
      this.props.getData && this.props.getData(true);
      this.props.onTransferred?.();

      toastMessage("success", `Product has been ${status} successfully`);
    } catch (error) {
      console.log(error);
      toastMessage("error", error);
      this.setState({
        [isLoading]: false,
      });
    }
  };

  handleRequest = async (
    isLoading,
    { id, status, shipmentNumber, from, to, requestNo, requestType }
  ) => {
    try {
      this.setState({
        [isLoading]: true,
      });

      this.props.dispatch(onGenerateShipmentNumber(true));

      const user = await getStorage();

      const API_URL = process.env.REACT_APP_BBMS_BASE_API;

      const options = {
        method: "PUT",
        url: `${API_URL}/shipping-queue`,
        data: {
          id,
          shipmentInfo: {
            status,
            user: user.id,
            date: moment().format("YYYY-MM-DD HH:mm"),
          },
          shipmentNumber,
          to,
          from,
          requestNo,
          requestType,
        },
        headers: {
          Authorization: `Bearer ${this.state.user.token}`,
        },
      };
      await api(options);

      this.setState({
        [isLoading]: false,
      });

      this.props.dispatch(onGenerateShipmentNumber(false));

      toastMessage("success", `Product has been ${status} successfully`);
    } catch (error) {
      this.setState({
        [isLoading]: false,
      });
    }
  };

  render() {
    const data = this.props.data || [];
    if (data.length === 0) return;

    const canUpdateTransfer =
      !!data.find((item) => item.status === "transferred") &&
      !!data.find((item) => item.status !== "transferred");
    const canCreateTransfer = !data.find(
      (item) => item.status === "transferred"
    );

    const canDelete =
      defineRole({
        roles: this.state.user.accessRole,
        menu: ROLE_REQUEST,
        operation: "delete",
      }) || !!this.props.isForNominative;

    return (
      <>
        <Table
          data={data}
          isSearch
          page={this.props.page}
          limit={this.props.limit}
          search_text={this.props.search_text}
          handleSearch={(e) =>
            handleSearch(this, { copyData, value: e.target.value })
          }
          showAdd={canCreateTransfer || canUpdateTransfer}
          addButtonText={
            canUpdateTransfer
              ? language[this.props.defaultLanguage].update
              : language[this.props.defaultLanguage].create
          }
          handleAddPressed={() => {
            this.handleShowModal("showPrint");
          }}
          searching={this.props.searching}
          totalPageCount={this.props.totalPageCount}
          isLoading={this.props.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          headers={this.returnTableHeaders()}
          actions={[
            {
              canAccess: !!this.props.isReturn,
              name: language[this.props.defaultLanguage].edit,
              icon: icons.edit,
              isHidden: (item) =>
                item.status?.toUpperCase() === "TRANSFERRED",
              onPress: (item) =>
                this.handleShowModal(
                  "showEditModal",
                  language[this.props.defaultLanguage].edit,
                  item
                ),
            },
            {
              canAccess: canDelete,
              name: language[this.props.defaultLanguage].delete,
              onPress: this.handleShowModal.bind(
                this,
                "showDeleteModal",
                language[this.props.defaultLanguage].delete
              ),
              icon: icons.delete,
            },
          ]}
        />
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showModal")}
          show={this.state.showModal}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
          size="lg"
        >
          {this.props.selectedData && (
            <UpdateShipping
              handleCloseModal={this.handleCloseModal.bind(this, "showModal")}
              getData={this.props.getData}
              {...this.props.selectedData}
            />
          )}
        </Modal>

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showPrint")}
          show={this.state.showPrint}
          // title="Shipment In Queue"
          showHeaderBottomBorder={false}
          size="lg"
          backdrop="static"
        >
          {this.props.selectedData && (
            <>
              <div className="modal-footer">
                <Button
                  text={language[this.props.defaultLanguage].close}
                  onPress={() => {
                    this.handleCloseModal("showPrint");
                  }}
                  className="btn-default"
                />

                {data.filter(
                  (el) => el.status?.toUpperCase() === "PENDING"
                )?.length > 0 && (
                  <Button
                    text={language[this.props.defaultLanguage].transfer}
                    onPress={() => {
                      this.handleUpdateRequest("isTransferring", {
                        ...this.props.selectedData,
                        id: this.props.selectedData._id,
                        to: this.props.selectedData?.to?._id || this.props.selectedData?.to,
                        from: this.props.selectedData?.from?._id || this.props.selectedData?.from,
                        status: "transferred",
                        requestType: this.props.isForNominative
                          ? "NOMINATIVE"
                          : undefined,
                      });
                    }}
                    isSubmitting={this.state.isTransferring}
                  />
                )}
              </div>
              <ShippingInQueue
                handleCloseModal={() => {
                  this.handleCloseModal("showPrint");
                }}
                shipmentNumber={
                  this.props.selectedData.shipmentNumber ||
                  this.props.selectedData.returnNumber
                }
                from={
                  this.props.selectedData.from ||
                  this.props.selectedData?.inventory?.stock
                }
                to={
                  this.props.selectedData.to ||
                  this.props.selectedData?.inventory?.sourceStock
                }
                // A shipment carrying a service was issued by the hospital's
                // own blood bank to one of its wards. `from` still holds where
                // the unit was originally supplied from (e.g. the Zipline hub),
                // which is the wrong end to print — the issuing stock is `to`.
                // ShippingInQueue prefers these over from/to when present.
                source={
                  this.props.selectedData?.service?.name
                    ? this.props.selectedData?.to?.name
                    : undefined
                }
                destination={this.props.selectedData?.service?.name}
                patient={this.props.selectedData?.inventory?.patient}
                addedBy={this.props.addedBy}
                status={this.props.selectedData.status || "pending"}
                createdAt={this.props.selectedData.createdAt}
                recepientName={this.props.selectedData.recepientName}
                isReturn={this.props.isReturn}
                returnId={this.props.selectedData._id}
              />
            </>
          )}
        </Modal>

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showEditModal")}
          show={this.state.showEditModal}
          title={this.state.modalTitle}
          size="lg"
        >
          {this.state.selectedData && (
            <UpdateReturnProduct
              item={this.state.selectedData}
              getData={this.props.getData}
              handleCloseModal={this.handleCloseModal.bind(this, "showEditModal")}
            />
          )}
        </Modal>

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showDeleteModal")}
          show={this.state.showDeleteModal}
          title={this.state.modalTitle}
        >
          {this.state.selectedData.status?.toUpperCase() === "PENDING" ||
          defineRole({
            roles: this.state.user.accessRole,
            menu: ROLE_DISTRIBUTION,
            operation: "admin",
          }) ? (
            <DeleteModal
              handleCloseModal={this.handleCloseModal.bind(
                this,
                "showDeleteModal"
              )}
              error={this.state.error.delete_password}
              value={this.state.delete_value}
              onDelete={this.onDelete.bind(this)}
              onChange={(e) => this.onChangeText("delete_value", e)}
              isDeleting={this.props.isDeleting}
              name={this.props.selectedData._id}
              getData={() => this.props.getData(true)}
            />
          ) : (
            <Empty
              title={`You can't delete data with ${this.state.selectedData.status} status`}
            />
          )}
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(ListShippingQueue);
